import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltips',
  templateUrl: './tooltips.component.html',
  styleUrls: ['./tooltips.component.scss'],
  standalone: false
})
export class TooltipsComponent implements OnInit {
  @Input() textHover: string;
  @Input() tooltipText: string;
  @Input() ariaLabel: string;

  @Input() from: string;

  constructor() {}

  ngOnInit(): void {}
}
